// extracted by extract-css-chunks-webpack-plugin
module.exports = {"storeInfoWrapper":"afLUw","storeName":"_-0Gh8","ulStoreTimeWrap":"jukan","storeTime":"_5cplb","storeLinkBtn":"-FlHR"};